<template>
  <section class="meters">
    <div class="row">
      <div class="col-lg-5">
        <div class="meters-info">
            <h1 class="title">{{ messages.meters.title }}</h1>
            <ul class="list-icon mobile">
                <li v-for="(item,index) in messages.meters.list"
                    v-bind:class="active===index ? 'active' : ''"
                    :key="index"
                    v-on:click="tab(index)">
                    <div v-bind:class="active!==index ? 'icon text-transform' : 'icon'">
                        <i v-bind:class="item.icon"></i>
                    </div>
                </li>
            </ul>
            <div class="height">
                <h1 class="content">{{ title }}</h1>
                <h1 class="content-list">{{ text }}</h1>
                <ul class="list" v-if="list.length!==0">
                    <li v-for="(item,index) in list" :key="index">
                        {{ item }}
                    </li>
                </ul>
            </div>
            <ul class="list-icon">
                <li v-for="(item,index) in messages.meters.list"
                    v-bind:class="active===index ? 'active' : ''"
                    :key="index"
                    v-on:click="tab(index)">
                    <div v-bind:class="active!==index ? 'icon text-transform' : 'icon'">
                        <i v-bind:class="item.icon"></i>
                    </div>
                </li>
            </ul>
        </div>
      </div>

      <div class="col-lg-7">
        <div class="bg-image" v-bind:style="'background-image: url('+require('./../assets/img/home.webp')+')'">
          <div class="mobile" data-toggle="modal" v-bind:style="'background-image: url('+require('./../assets/img/'+background)+');'">

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "meters_component",
  data(){
    return {
      messages:{},
      title:'',
      text:'',
      list:[],
      icon:'',
      background:'',
      active:0
    };
  },
  methods:{
    tab(index){
      this.title = this.messages.meters.list[index].title;
      this.text = this.messages.meters.list[index].text;
      this.list = this.messages.meters.list[index].list !== undefined ? this.messages.meters.list[index].list : [];
      this.icon = this.messages.meters.list[index].icon;
      this.background = this.messages.meters.list[index].image;
      this.active = index;
    }
  },
  beforeMount(){
    this.messages = window.messages;
    this.title = this.messages.meters.list[0].title;
    this.text = this.messages.meters.list[0].text;
    this.icon = this.messages.meters.list[0].icon;
    this.background = this.messages.meters.list[0].image;
    this.list = this.messages.meters.list[0].list !== undefined ? this.messages.meters.list[0].list : [];
  },
  mounted() {
    window.addEventListener('scroll', () => {
      const div = document.querySelector(".meters")

      if (document.documentElement.scrollTop > div.scrollTop + 1900) {
        div.querySelector(".bg-image").classList.add('fadeInDown');
        div.querySelector(".bg-image").querySelector(".mobile").classList.add('fadeInDown');
      }
    });
  }
}
</script>

<style scoped>

</style>